import React from "react";

/* The way back to the document once it has been closed.
 *
 * The panel opens itself when writing starts, so this is dead weight most of the
 * time - which is exactly why it renders nothing while the panel is open rather
 * than sitting there greyed. A control that is present but inert reads as
 * broken; one that appears when it becomes useful reads as the product noticing.
 *
 * It lives on the cards because that is where the user's attention is when they
 * want it back: they have just read a stat line about a section and want to see
 * the section. Anywhere else would be a hunt.
 */
const Eye = () => (
  <svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const ShowDocumentButton = ({ open, onOpen, label = "Read the draft", iconOnly = false }) => {
  if (open) return null;

  /* In the card's header strip there is room for a glyph and nothing else, so
   * the label becomes a tooltip. `title` AND `aria-label`: the tooltip is for
   * the pointer, the label is what a screen reader announces, and an icon
   * button without the second one is a button that says "button". */
  if (iconOnly) {
    return (
      <button
        type="button"
        onClick={onOpen}
        title={label}
        aria-label={label}
        className="flex h-6 w-6 items-center justify-center rounded-md text-[#8E4187] transition-colors duration-150 hover:bg-[#A04A97]/[0.12] hover:text-[#6F3369] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#A04A97] motion-reduce:transition-none"
      >
        <Eye />
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onOpen}
      className="group/doc inline-flex items-center gap-1.5 text-[12.5px] font-medium text-[#8E4187] transition-colors duration-150 hover:text-[#6F3369] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#A04A97] focus-visible:ring-offset-2 motion-reduce:transition-none"
    >
      {/* An eye, deliberately not a panel outline. The bordered-rectangle-with-a
          divider is already the toggle for BOTH the chat history rail and the
          main sidebar; a third use of it in the same view stops meaning
          anything. This one has no rectangle at all, and "view" is the honest
          verb - the document exists either way, only its visibility changes. */}
      <Eye />
      <span className="underline decoration-[#8E4187]/25 decoration-1 underline-offset-[3px] transition-colors group-hover/doc:decoration-[#6F3369]/60 motion-reduce:transition-none">
        {label}
      </span>
    </button>
  );
};

export default ShowDocumentButton;
